import React from 'react';

import { TEXTS } from 'application/pages/AdsPage/renderer/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import styles from './index.module.scss';

export interface DisabledInstantAdHintProps {
  isLinkDisabled?: boolean;
  onClick: () => void;
}

const DisabledInstantAdHint = ({ isLinkDisabled = false, onClick }: DisabledInstantAdHintProps) => {
  const handleLinkMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (!isLinkDisabled) {
      onClick();
    }
  };

  const handleLinkClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    if (!isLinkDisabled) {
      onClick();
    }
  };

  return (
    <>
      {`${TEXTS.AD_TYPE_INSTANT_DISABLED_HINT}`}
      <br />
      <Button
        elementId="disabled_instant_ad_hint_button_to_promo"
        className={styles.DisabledInstantAdHint}
        isDisabled={isLinkDisabled}
        onClick={handleLinkClick}
        onMouseDown={handleLinkMouseDown}
        type={ButtonType.PLAIN}>
        {TEXTS.AD_TYPE_INSTANT_DISABLED_HINT_LINK}
      </Button>
    </>
  );
};

export default DisabledInstantAdHint;
